module.exports = __webpack_public_path__ + "static/media/blk.87385553.svg";